import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Alert } from 'react-bootstrap'
import PageHeader from '../../../../layout/page/PageHeader'
import useAxiosPrivate from '../../../../../hooks/useAxiosPrivate'
import NewsletterForm from './NewsletterForm'
import { Newsletter } from './Newsletter.d'

const View = () => {
    const { newsletterId } = useParams()
    const axiosPrivate = useAxiosPrivate()

    const [newsletter, setNewsletter] = useState<Newsletter | null>(null)
    const [translations, setTranslations] = useState<Record<string, any>>({})
    const [isLoading, setIsLoading] = useState(true)
    const [errMsg, setErrMsg] = useState('')

    const loadNewsletter = useCallback(async () => {
        setErrMsg('')
        setIsLoading(true)

        try {
            const response = await axiosPrivate
                .get(`/newsletters/${newsletterId}`)
                .finally(() => setIsLoading(false))

            if (response.data?.success) {
                setNewsletter(response.data.data.newsletter)
                setTranslations(response.data.data.translations || {})
            } else {
                setErrMsg('Failed to load newsletter')
            }
        } catch (err) {
            setErrMsg('Failed to load newsletter')
        }
    }, [axiosPrivate, newsletterId])

    useEffect(() => {
        loadNewsletter()
    }, [loadNewsletter])

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    return (
        <>
            <PageHeader
                icon="envelope"
                subtitle="View and edit email campaign"
                gradient="linear-gradient(135deg, #f59e0b, #d97706)"
                header="Edit Email Campaign"
            />
            {errMsg && <Alert variant="danger">{errMsg}</Alert>}
            {newsletter && (
                <NewsletterForm
                    newsletter={newsletter}
                    isEditing
                    translations={translations}
                />
            )}
        </>
    )
}

export default View
